import { comments } from '@/mocks/homeData';

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-chat-smile-2-line"></i>
            <span>真实反馈</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">读者评价</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            来自五百万漫迷的真实声音
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
          {comments.map((comment, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100/60 flex items-center justify-center text-xl flex-shrink-0">
                  {comment.avatar}
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
                <div className="ml-auto flex-shrink-0">
                  <span className="px-2 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {comment.comic}
                  </span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-1 mt-4 text-accent-500">
                {[1, 2, 3, 4, 5].map((star) => (
                  <div key={star} className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-xs"></i>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}